import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-custom-tooltip',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './custom-tooltip.component.html',
  styleUrl: './custom-tooltip.component.css',
})
export class CustomTooltipComponent {
  @Input() content: string = '';
  @Input() show: boolean = false;

  direction: 'top' | 'bottom' = 'bottom';
  positioned = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('window:resize')
  onResize() {
    this.adjustPosition();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['show']?.currentValue) {
      setTimeout(() => this.adjustPosition(), 0);
    }
  }

  ngAfterViewInit(): void {
    if (this.show) {
      setTimeout(() => this.adjustPosition(), 0);
    }
  }

  private adjustPosition() {
    const tooltipEl = this.el.nativeElement.querySelector('.custom-popup');
    const parentRect =
      this.el.nativeElement.parentElement?.getBoundingClientRect();

    if (tooltipEl && parentRect) {
      const tooltipHeight = tooltipEl.offsetHeight;
      const spaceBelow = window.innerHeight - parentRect.bottom;

      this.direction = spaceBelow < tooltipHeight + 20 ? 'top' : 'bottom';

      this.positioned = true;
    }
  }
}
